(function(angular) {
	'use strict';
	/**
	 * Modal service
	 */
	var core = angular.module('Core');

	core.service('ModalService', ['$modal', '$timeout', '$q', '$sce', '$translate',
		function ($modal, $timeout, $q, $sce, $translate) {

			this.nbShown = 0;
			this.zIndexStart = 9000000;

			var lockModalOpened = false;
			var lockedModalInstance = null;

			this.crtModalId = 1;
			var instance = this;

			var infoModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null" stl-shortcut>' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}}' +
					'<div ng-if="htmlTxt" ng-bind-html="htmlTxt"></div>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{validateBtnCls }}" ng-click="validate()">{{validateBtn | translate}}</button>' +
					'</div>';
			var inputModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}} : ' +
					'<input ng-model="input" type="text"/>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{cancelBtnCls}}" ng-click="cancel()">{{cancelBtn | translate}}</button>' +
					'<button class="btn {{validateBtnCls}}" ng-click="validate(input)">{{validateBtn | translate}}</button>' +
					'</div>';
			var textareaModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}} : <br />' +
					'<textarea style="width:100%" ng-model="input.txt"></textarea>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{validateBtnCls}}" ng-click="validate(input)">{{validateBtn | translate}}</button>' +
					'<button class="btn {{cancelBtnCls}}" ng-click="cancel()">{{cancelBtn | translate}}</button>' +
					'</div>';
			var selectModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}} : ' +
					'<ui-select ng-model="input" theme="bootstrap" ng-change="change($select.selected)" append-to-body="true" class="width-200">' +
					'<ui-select-match>' +
					'{{$select.selected.label}}' +
					'</ui-select-match>' +
					'<ui-select-choices repeat="d in $data | filter: {label: $select.search }">' +
					'<div ng-bind-html="d.label | highlight: $select.search"></div>' +
					'</ui-select-choices>' +
					'</ui-select>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{validateBtnCls}}" ng-disabled="!input" ng-click="validate(input)">{{validateBtn | translate}}</button>' +
					'<button class="btn {{cancelBtnCls}}" ng-click="cancel()">{{cancelBtn | translate}}</button>' +
					'</div>';

			var confirmationModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null" stl-shortcut>' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}}' +
					'<div ng-if="htmlTxt" ng-bind-html="htmlTxt"></div>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{validateBtnCls}}" ng-click="ok()">{{validateBtn | translate}}</button>' +
					'<button class="btn {{cancelBtnCls}}" ng-click="cancel()">{{cancelBtn | translate}}</button>' +
					'</div>';
			var lockModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body lockModal">' +
					'{{modalText | translate}}' +
					'</div>';
			var downloadPopupTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}}' +
					'</div>' +
					'<div class="modal-footer">' +
					'<a href="{{link}}" download class="btn {{validateBtnCls}}" ng-click="close()" target="_blank">{{validateBtn | translate}}</a>' +
					'<button class="btn {{cancelBtnCls}}" ng-click="close()">{{cancelBtn | translate}}</button>' +
					'</div>';
			var imageShowTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body" style="text-align:center">' +
					'<img ng-src={{src}} />' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{cancelBtnCls}}" ng-click="close()">{{cancelBtn | translate}}</button>' +
					'</div>';
			var multiButtonsTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}}' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button ng-repeat="btn in buttons" class="btn {{btn.btnClass}}" ng-click="btn.action(close)">{{btn.text | translate}}</button>' +
					'</div>';
			function globalInit($scope, options) {
				$scope.modalTitle = null;
				if (options['modalTitle'] !== undefined) {
					$scope.modalTitle = options['modalTitle'];
				}

				$scope.modalText = options['modalText'];

				if (!options['validateBtn']) {
					$translate('Continuer').then(function (translatedValue) {
						$scope.validateBtn = translatedValue;
					});
				} else {
					$scope.validateBtn = options['validateBtn'];
				}

				if (!options['cancelBtn']) {
					$translate('Annuler').then(function (translatedValue) {
						$scope.cancelBtn = translatedValue;
					});
				} else {
					$scope.cancelBtn = options['cancelBtn'];
				}

				if (!options['validateBtnCls']) {
					$scope.validateBtnCls = 'btn-primary';
				} else {
					$scope.validateBtnCls = options['validateBtnCls'];
				}

				if (!options['cancelBtnCls']) {
					$scope.cancelBtnCls = 'btn-default';
				} else {
					$scope.cancelBtnCls = options['cancelBtnCls'];
				}

				if (options['htmlText']) {
					$scope.htmlTxt = $sce.trustAsHtml(options['htmlText']);
				}
			}

			function setZIndex(zindex, id, time) {
				$timeout(function() {
					var modalBody = $('#modal-bts-' + id);
					var modal = modalBody.parent().parent().parent();
					modal.css('z-index', zindex + 1);
					modal.prev().css('z-index', zindex);
				}, time);
			}

			function resolveOpened(modalPromise) {
				var id = instance.crtModalId;
				var zindex = instance.zIndexStart + (instance.nbShown * 2 /* Z-Index form modal + back drop.. */);
				modalPromise.opened.then(function() {
					setZIndex(zindex, id, 0);
					setZIndex(zindex, id, 200);
				});
			}

			function resolvePromise(defered, modalPromise) {

				resolveOpened(modalPromise);

				modalPromise.result.then(function(data) {
					defered.resolve(data);
				},
						function() {
							defered.reject();
						});
			}

			function getTemplate(template) {
				return template.replace('{modal-id}', 'modal-bts-' + instance.crtModalId);
			}

			return {
				/*
				 options {
				   	validateBtn : "validate button text"
				   	cancelBtn : "cancel button text"
				  	validateBtnCls : btn-primary | btn-danger ...
				  	cancelBtnCls : btn-primary | btn-danger ...
				  	modalTitle : "the title if null header are hidden"
				 	modalText : "the title if null header are hidden"
					htmlText : "HTML txt"
				}
				 */
				confirmationModal: function(options, validateCallBack, cancelCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(confirmationModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									var canceled = false;
									globalInit($scope, options);

									$scope.ok = function() {
										$modalInstance.close();
										if (validateCallBack) {
											validateCallBack();
										}
									};

									$scope.cancel = function() {
										canceled = true;
										$modalInstance.dismiss('cancel');
										if (cancelCallBack) {
											cancelCallBack();
										}
									};

									$scope.keyPressed = function (e) {
										if (e.which === 13) {
											$scope.ok();
										}
									};

									$modalInstance.result.then(function() {
									}, function() {
										if (canceled === false && cancelCallBack) {
											cancelCallBack();
										}
									});
								}]
						}));
					}, 20);
					return defered.promise;
				},
				/* options {
				 validateBtn : "validate button text"
				 cancelBtn : "cancel button text"
				 validateBtnCls : btn-primary | btn-danger ...
				 cancelBtnCls : btn-primary | btn-danger ...
				 modalTitle : "the title if null header are hidden"
				 modalText : "the title if null header are hidden"
				 }
				 buttons: [button]
				 buttn: {
				 btnClass: css,
				 action: function,
				 text: string
				 }
				 *
				 */
				multiButtonsModal: function(options, buttons) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(multiButtonsTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									globalInit($scope, options);

									var managedButtons = [];
									var cancelFn = function() {
										$scope.cancel();
									};
									for (var i = 0; i < buttons.length; i++) {
										var fn = buttons[i].action;
										if (!fn) {
											buttons[i].action = cancelFn;
										}
										managedButtons.push(buttons[i]);
									}
									$scope.buttons = managedButtons;

									$scope.cancel = function() {
										$modalInstance.dismiss('cancel');
									};

									$scope.close = function() {
										$scope.cancel();
									};

									$modalInstance.result.then(function() {
									}, function() {
									});
								}]
						}));
					}, 20);
					return defered.promise;
				},

				inputModal: function(options, cancelCallBack, validateCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(inputModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									if (!options.cancelBtn) {
										$translate('Ok').then(function (translatedValue) {
											options.cancelBtn = translatedValue;
										});
									}
									globalInit($scope, options);
									if (options.defaultValue) {
										$scope.input = options.defaultValue;
									}
									$scope.cancel = function() {
										$modalInstance.dismiss('cancel');
										if (cancelCallBack) {
											cancelCallBack();
										}
									};
									$scope.validate = function(input) {
										$modalInstance.close(input);
										if (validateCallBack) {
											validateCallBack(input);
										}
									};
								}]
						}));
					}, 20);
					return defered.promise;
				},
				textareaModal: function(options, cancelCallBack, validateCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(textareaModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									if (!options.cancelBtn) {
										$translate('Ok').then(function (translatedValue) {
											options.cancelBtn = translatedValue;
										});
									}
									$scope.input = {};

									globalInit($scope, options);
									if (options.defaultTxt) {
										$scope.input.txt = options.defaultTxt;
									}
									$scope.cancel = function() {
										$modalInstance.dismiss('cancel');
										if (cancelCallBack) {
											cancelCallBack();
										}
									};
									$scope.validate = function(input) {
										$modalInstance.close(input.txt);
										if (validateCallBack) {
											validateCallBack(input.txt);
										}
									};
								}]
						}));
					}, 20);
					return defered.promise;
				},
				/* options :
				 * (facultatif) preSelectedObject : objet de la liste preselectionne
				 */
				selectModal: function(options, cancelCallBack, validateCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: function() {
								return getTemplate(selectModalTemplate);
							},
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									$scope.$data = options.data;
									globalInit($scope, options);
									if (options.defaultValue) {
										$scope.input = options.defaultValue;
									}
									$scope.cancel = function() {
										$modalInstance.dismiss('cancel');
										if (cancelCallBack) {
											cancelCallBack();
										}
									};
									$scope.validate = function (input) {
										$modalInstance.close(input.id);
										if (validateCallBack) {
											validateCallBack(input);
										}
									};
									$scope.change = function (input) {
										$scope.input = input;
									};
								}]
						}));
					}, 20);
					return defered.promise;
				},
				infoModal: function(options, validateCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(infoModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									if (!options.cancelBtn) {
										$translate('Ok').then(function (translatedValue) {
											options.cancelBtn = translatedValue;
										});
									}
									globalInit($scope, options);

									$scope.validate = function() {
										$modalInstance.close();
										if (validateCallBack) {
											validateCallBack();
										}
									};

									$scope.keyPressed = function (e) {
										if (e.which === 13) {
											$scope.validate();
										}
									};
								}]
						}));
					}, 20);
					return defered.promise;
				},
				downloadPopup: function(options) {
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolveOpened($modal.open({
							template: getTemplate(downloadPopupTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									globalInit($scope, options);
									$scope.link = options['link'];
									$scope.close = function() {
										$modalInstance.dismiss('cancel');
									};
								}]
						}));
					}, 20);
				},
				imageShow: function(options) {
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolveOpened($modal.open({
							windowClass: 'imageShow',
							template: getTemplate(imageShowTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									globalInit($scope, options);
									$scope.src = options['src'];
									$scope.close = function() {
										$modalInstance.dismiss('cancel');
									};
								}]
						}));
					}, 20);
				},
				lockModal: function(options) {

					if (lockModalOpened) {
						return;
					}
					lockModalOpened = true;
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						lockedModalInstance = $modal.open({
							backdrop: 'static',
							keyboard: false,
							template: getTemplate(lockModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									globalInit($scope, options);

									$modalInstance.result.then(function() {
									}, function() {
										lockModalOpened = false;
										lockedModalInstance = null;
									});
								}]
						});
					}, 20);
				},
				unLockModal: function() {
					if (lockedModalInstance) {
						lockedModalInstance.dismiss('cancel');
					}
				},
				getNbShown: function() {
					return instance.nbShown;
				},
				incNbShown: function() {
					return ++instance.nbShown;
				},
				getZIndexStart: function() {
					return instance.zIndexStart;
				}
			};

		}]);



	/* Modal directives */
	core.directive('stlModal', ['$timeout', 'ModalService', function($timeout, ModalService) {
			var nbCreated = 0;
			var nbOpened = 0;

			var shown = [];

			return {
				restrict: 'E',
				scope: {
					modal: '=',
					visible: '=',
					closable: '@',
					onClose: '&'
				},
				replace: true,
				transclude: true,
				template:
						'<div ng-show="visible" id="{{id}}" class="stl-modal-container">' +
						'<div ng-if="visible && modal" class="stl-modal-back modal-backdrop in"></div>' +
						'<div class="stl-modal">' +
						'<div class="modal" role="dialog">' +
						'<div ng-if="visible" class="modal-content" ng-transclude></div>' +
						'</div>' +
						'</div>' +
						'</div>',
				link: function(scope, element) {
					nbCreated++;
					var id = 'stl-modal-' + nbCreated;
					var visible = false;

					var eventsAdded = false;

					var isCurrent = function() {
						if (shown[shown.length - 1] === id) {
							return true;
						}
						return false;
					};

					var setBackVisible = function(zIndex) {
						var elt = element.find('.stl-modal-back');
						elt.css('z-index', zIndex);
					};


					var eventName = 'keyup.' + id;
					var clickEventName = 'click.' + id;

					var removeEvents = function() {
						if (eventsAdded) {
							$(document).unbind(eventName);
							$(document).unbind(clickEventName);
							eventsAdded = false;
						}
					};

					var initEvents = function() {
						$timeout(function() {
							if (scope.isClosable() && scope.visible) {
								$(document).on(eventName, function(e) {
									var code = e.keyCode ? e.keyCode : e.which;
									if (isCurrent() && code === 27) {
										$timeout(function() {
											scope.visible = false;
										});
									}
								});

								$(document).on(clickEventName, function(e) {
									/*var sel = '#' + id + ' .modal';
									 if (isCurrent() && !$(e.target).closest(sel).length) {
									 if ($(sel).is(":visible")) {
									 $timeout(function() {
									 scope.visible = false;
									 });
									 }
									 }*/
								});

								eventsAdded = true;
							}
						}, 0);
					};


					var setVisible = function(newVal) {
						if (newVal !== undefined && newVal !== null) {
							var modal = element.find('.stl-modal').first();
							var modalBS = element.find('.modal').first();
							if (newVal === true) {
								// new shown...
								ModalService.incNbShown();
								var zIndex = ModalService.getZIndexStart() + (ModalService.getNbShown() * 2 /* Z-Index form modal + back drop.. */);
								modal.css('z-index', zIndex + 1);
								modalBS.css('z-index', zIndex + 1);

								setBackVisible(zIndex);

								nbOpened++;
								visible = true;

								if (!eventsAdded) {
									initEvents();
								}

								shown.push(id);

							} else if (visible === true) {
								nbOpened--;
								if (nbOpened === 0) {
									setBackVisible();
								}
								if (scope.onClose) {
									scope.onClose();
								}
								visible = false;

								removeEvents();
								shown.pop();
							}
						}
					};

					setVisible(scope.visible);

					scope.id = id;

					scope.$watch('visible', function(newVal, oldVal) {
						if (newVal !== oldVal) {
							setVisible(newVal);
						}
					});
					scope.$watch('modal', function(newVal, oldVal) {
						if (newVal !== oldVal) {
							applyBackVisible(newVal);
						}
					});


					var cleanUp = function() {
						$('#' + id).remove();
						removeEvents();
					};

					scope.$on('$destroy', function() {
						cleanUp();
					});
				},
				controller: ['$scope', function($scope) {

						$scope.isClosable = function() {
							var closable = true;
							if ($scope.closable === 'false') {
								closable = false;
							}
							return closable;
						};

						this.hide = function() {
							$scope.visible = false;
						};

						this.isClosable = function() {
							return $scope.isClosable();
						};

						this.isAutoResized = function() {
							if ($('#' + $scope.id).attr('class')) {
								return $('#' + $scope.id).attr('class').indexOf('stl-modal-dialog') < 0;
							}
							return false;
						};
					}]
			};
		}]);
	core.directive('stlModalHead', [function() {
			return {
				restrict: 'E',
				replace: true,
				transclude: true,
				require: '^stlModal',
				template:
						'<div class="modal-header">' +
						'<button ng-if="closable" type="button" ng-click="hide()" class="close">&times;</button>' +
						'<h4 class="modal-title" ng-transclude></h4>' +
						'</div>',
				link: function(scope, element, attr, stlModal) {
					scope.closable = stlModal.isClosable();

					scope.hide = function() {
						stlModal.hide();
					};
				}
			};
		}]);
	core.directive('stlModalBody', ['$window', function($window) {
			return {
				scope: false,
				require: '^stlModal',
				restrict: 'E',
				replace: true,
				transclude: true,
				template:
						'<div class="modal-body" ng-style="height" ng-transclude>' +
						'</div>',
				link: function(scope, element, attribute, stlModal) {

					var getInfos = function() {
						return {
							scroll: element.scrollTop(),
							height: element.height(),
							outerHeight: element.outerHeight(),
							innerHeight: element.innerHeight(),
							scrollHeiht: element[0].scrollHeight,
							top: element.offset().top,
							left: element.offset().left
						};
					};

					element.on('scroll', function(e) {
						scope.$broadcast('modal-body-scroll', getInfos());
					});

					$(window).on('resize', function(e) {
						scope.$broadcast('modal-body-resize', getInfos());
					});

					if (stlModal.isAutoResized()) {
						angular.element($window).bind('resize', function() {
							if (stlModal.isAutoResized()) {
								scope.$apply(function() {
									scope.height = {height: window.innerHeight * 0.8 - 120 + 'px'};
								});
							}
						});
						scope.height = {height: (window.innerHeight * 0.8 - 120) + 'px'};
					} else {
						if (attribute['minHeight']) {
							scope.height = {height: attribute['minHeight'] + 'px'};
						} else {
							scope.height = {height: 'auto'};
						}

					}
				}
			};
		}]);
	core.directive('stlModalFooter', [function() {
			return {
				require: '^stlModal',
				scope: {
					showCloseButton: '@?'
				},
				restrict: 'E',
				replace: true,
				transclude: true,
				template:
						'<div class="modal-footer">' +
						'<span ng-transclude></span>' +
						'<button ng-if="showCloseButton" type="button" class="btn btn-primary" ng-click="hide()"><i18n key="bouton.fermer"></i18n></button>' +
						'</div>',
				link: function(scope, element, attrs, stlModal) {
					scope.hide = function() {
						stlModal.hide();
					};

					if (scope.showCloseButton === 'false') {
						scope.showCloseButton = false;
					}
				}
			};
		}]);
})(angular);